type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;
type LoggerLike = Pick<Console, "log" | "warn" | "error">;

export const SERVER_PLATFORM_EMAIL_BOOTSTRAP_SQL = [
  `CREATE TABLE IF NOT EXISTS platform_email_outbox (
    id SERIAL PRIMARY KEY,
    idempotency_key TEXT NOT NULL UNIQUE,
    template_key TEXT NOT NULL,
    template_version INTEGER NOT NULL DEFAULT 1,
    recipient_user_id TEXT,
    recipient_email TEXT NOT NULL,
    payload_json TEXT NOT NULL DEFAULT '{}',
    subject TEXT,
    status TEXT NOT NULL DEFAULT 'queued',
    attempt_count INTEGER NOT NULL DEFAULT 0,
    next_attempt_at TIMESTAMP DEFAULT NOW(),
    provider TEXT,
    provider_message_id TEXT,
    last_error TEXT,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL,
    sent_at TIMESTAMP
  )`,
  `CREATE INDEX IF NOT EXISTS idx_platform_email_outbox_status_next_attempt
    ON platform_email_outbox (status, next_attempt_at)`,
  `CREATE INDEX IF NOT EXISTS idx_platform_email_outbox_recipient_user
    ON platform_email_outbox (recipient_user_id, created_at)`,
  `CREATE INDEX IF NOT EXISTS idx_platform_email_outbox_template_created
    ON platform_email_outbox (template_key, created_at)`,
  `CREATE TABLE IF NOT EXISTS platform_email_templates (
    id SERIAL PRIMARY KEY,
    key TEXT NOT NULL UNIQUE,
    display_name TEXT NOT NULL,
    description TEXT,
    variable_schema_json TEXT NOT NULL DEFAULT '{}',
    created_by TEXT NOT NULL,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `CREATE TABLE IF NOT EXISTS platform_email_template_versions (
    id SERIAL PRIMARY KEY,
    template_id INTEGER NOT NULL,
    version INTEGER NOT NULL,
    status TEXT NOT NULL DEFAULT 'draft',
    layout_key TEXT NOT NULL DEFAULT 'activation',
    body_format TEXT NOT NULL DEFAULT 'markdown',
    subject TEXT NOT NULL,
    markdown_body TEXT NOT NULL,
    compiled_html TEXT,
    compiled_text TEXT,
    created_by TEXT NOT NULL,
    published_by TEXT,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL,
    published_at TIMESTAMP,
    UNIQUE (template_id, version)
  )`,
  `ALTER TABLE platform_email_template_versions
    ADD COLUMN IF NOT EXISTS layout_key TEXT NOT NULL DEFAULT 'activation'`,
  `ALTER TABLE platform_email_template_versions
    ALTER COLUMN layout_key SET DEFAULT 'activation'`,
  `ALTER TABLE platform_email_template_versions
    ADD COLUMN IF NOT EXISTS body_format TEXT NOT NULL DEFAULT 'markdown'`,
  `ALTER TABLE platform_email_template_versions
    ALTER COLUMN body_format SET DEFAULT 'markdown'`,
  `CREATE INDEX IF NOT EXISTS idx_platform_email_template_versions_template_status
    ON platform_email_template_versions (template_id, status, version)`,
  `CREATE TABLE IF NOT EXISTS platform_email_settings (
    key TEXT PRIMARY KEY,
    value_json TEXT NOT NULL DEFAULT '{}',
    updated_by TEXT,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `CREATE TABLE IF NOT EXISTS platform_email_audit_log (
    id SERIAL PRIMARY KEY,
    actor_user_id TEXT NOT NULL,
    action TEXT NOT NULL,
    target_type TEXT NOT NULL,
    target_id TEXT NOT NULL,
    metadata_json TEXT NOT NULL DEFAULT '{}',
    created_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `CREATE INDEX IF NOT EXISTS idx_platform_email_audit_log_actor_created
    ON platform_email_audit_log (actor_user_id, created_at)`,
  `CREATE TABLE IF NOT EXISTS platform_email_broadcasts (
    id SERIAL PRIMARY KEY,
    created_by TEXT NOT NULL,
    category TEXT NOT NULL,
    target_json TEXT NOT NULL,
    body_format TEXT NOT NULL DEFAULT 'markdown',
    subject TEXT NOT NULL,
    body_content TEXT NOT NULL,
    content_hash TEXT NOT NULL,
    status TEXT NOT NULL DEFAULT 'previewed',
    recipient_count INTEGER NOT NULL DEFAULT 0,
    send_key_hash TEXT,
    test_sent_at TIMESTAMP,
    enqueued_at TIMESTAMP,
    created_at TIMESTAMP DEFAULT NOW() NOT NULL,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `CREATE INDEX IF NOT EXISTS idx_platform_email_broadcasts_created_by_created
    ON platform_email_broadcasts (created_by, created_at DESC)`,
  `CREATE TABLE IF NOT EXISTS platform_email_preferences (
    user_id TEXT NOT NULL,
    category TEXT NOT NULL,
    unsubscribed_at TIMESTAMP,
    updated_at TIMESTAMP DEFAULT NOW() NOT NULL,
    PRIMARY KEY (user_id, category)
  )`,
  `CREATE INDEX IF NOT EXISTS idx_platform_email_preferences_user_category
    ON platform_email_preferences (user_id, category)`,
];

export async function ensurePlatformEmailSchema(params: {
  rawSql: RawSql;
  isPlatform: boolean;
  logger?: LoggerLike;
}): Promise<void> {
  if (!params.isPlatform) return;
  const logger = params.logger ?? console;
  for (const statement of SERVER_PLATFORM_EMAIL_BOOTSTRAP_SQL) {
    await params.rawSql(statement);
  }
  logger.log("[db] platform email schema ✓");
}
